import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { CountdownComponent } from '../countdown/countdown.component';
import { UserInactivityComponent } from './user-inactivity.component';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
  declarations: [UserInactivityComponent],
  imports: [CommonModule, IonicModule, CountdownComponent, SharedModule],
  exports: [UserInactivityComponent],
})
export class UserInactivityModule {}
